import React, { useState, useEffect } from 'react'
import styled, { css } from 'styled-components'

import { SVG } from './UI'

import glassA from '../assets/loading/glass_a.svg'
import glassB from '../assets/loading/glass_b.svg'
import glassC from '../assets/loading/glass_c.svg'
import glassD from '../assets/loading/glass_d.svg'
import glassE from '../assets/loading/glass_e.svg'
import glassF from '../assets/loading/glass_f.svg'

const SHolder = styled.div`
    pointer-events: none;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 15rem;

    @media only screen and (max-width: ${p => p.theme.mobileWidth}) {
        right: 0;
        bottom: 10rem;
    }
`

const SLoading = styled.div<{ small: boolean }>`
    position: absolute;

    height: 15rem;
    width: 20rem;

    display: grid;
    grid-template-rows: auto 3rem;

    ${p => !p.small && css`
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    `}

    ${p => p.small && css`
        transform: scale(.3, .3); 
        transform-origin: bottom right;
        right: 1rem;
        bottom: 1rem;
    `}
`

const SGlasses = styled.div`
    position: relative;
`

const SGlass = styled.div<{ on: boolean }>`
    position: absolute;
    top: 0; 
    bottom: 0;
    left: ${p => p.on ? 0 : '2rem'};
    right: 0;
    width: 100%;
    height: 100%;

    opacity: ${p => p.on ? 1 : 0};
    transition: ${p => p.on ? '.5s' : 0};
`

const SDots = styled.div`
    display: grid;
    grid-auto-flow: column;
    grid-gap: 1rem;
    margin: auto;
`

const SDot = styled.div<{ on: boolean }>`
    height: 1.2rem;
    width: 1.2rem;
    border-radius: 50%;
    background-color: ${p => p.on ? p.theme.colors.light : p.theme.colors.lightDark};
    transition: .5s;
`

interface IState {
	dot: number,
	glass: number
}

export default function Loading(props: { small: boolean }) {
	const [state, set] = useState<IState>({
		dot: 0,
		glass: 0
	})

	const glasses = [glassA, glassB, glassC, glassD, glassE, glassF]
	const tiempo = .7

	useEffect(() => {
		const interval = setInterval(() => {
			set(prev => {
				return {
					...prev,
					dot: (prev.dot + 1 > 2) ? 0 : prev.dot + 1,
					glass: (prev.glass + 1 >= glasses.length) ? 0 : prev.glass + 1
				}
			})
		}, tiempo * 1000)

		return () => clearInterval(interval)
	}, [])

	return (
		<SHolder>
			<SLoading small={props.small}>
				<SGlasses>
					{glasses.map((v, i) => <SGlass on={i === state.glass} key={i}><SVG image={v} /></SGlass>)}
				</SGlasses>
				<SDots>
					<SDot on={state.dot === 0} />
					<SDot on={state.dot === 1} />
					<SDot on={state.dot === 2} />
				</SDots>
			</SLoading>
		</SHolder>
	)
}
